import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign, formatCurrency } from "../../../Constants/utils";
import { getGrossProfit } from "../../../Redux/features/Dashboard/Charts/grossProfitChartSlice";
import { CommonChart } from "./CommonChart";

export const GrossProfitChart = ({
  merchantId,
  activeType,
  presentDate,
  grossProfitChartInView,
  grossProfitChartRef,
  selectedOutletIds = [],
}) => {
  const grossProfitChart = useSelector((state) => state.grossProfitChart);
  const chartKey = "grossProfitChart";

  return (
    <>
      <CommonChart
        componentRef={grossProfitChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getGrossProfit}
        yAxisText={"Metric (e.g., revenue in $)"}
        reduxState={grossProfitChart}
        reduxStateKey={"grossProfitData"}
        reduxStateTotalKey={"totalGrossProfit"}
        valueKey={"gross_profit"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={grossProfitChartInView}
        title={"Profit Generated"}
        totalValueFunction={formatCurrency}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
